import Storage from '@/lib/Storage'
import { uncachedClient } from '@/stackGqlClient'
import { gql } from '@apollo/client'
import { captureException } from '@sentry/react'
import { EarningsSummaryDTO } from '../types/EarningsSummary'

type Params = {
  startDate?: Date
  endDate?: Date
}

const getEarningsSummary = async ({
  startDate,
  endDate
}: Params): Promise<EarningsSummaryDTO[]> => {
  const activeRole = Storage().getActiveRole()
  const { id, type, organizationId } = activeRole

  return uncachedClient
    .query({
      query: gql`
        query (
          $organizationId: Int!
          $type: PartnerType!
          $id: Int!
          $startDate: Date
          $endDate: Date
        ) {
          viewer {
            ... on OrgUser {
              organization(id: $organizationId) {
                earningsSummary(
                  partnerType: $type
                  partnerId: $id
                  startDate: $startDate
                  endDate: $endDate
                ) {
                  edges {
                    node {
                      earningsAmountInCents
                      paidSpendsAmountInCents
                      netEarningsAmountInCents
                      sales
                      date
                      paidSpendsRunningTotalInCents {
                        source
                        amount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: {
        id,
        type,
        organizationId,
        startDate,
        endDate
      }
    })
    .then((result) => {
      if (result.errors) return []

      const edges = result.data.viewer.organization.earningsSummary.edges
      return edges.map((edge: { node: EarningsSummaryDTO }) => {
        const node = edge.node
        return {
          ...node,
          earningsAmount: node.earningsAmountInCents / 100,
          netEarningsAmount: node.netEarningsAmountInCents / 100,
          date: new Date(node.date)
        }
      })
    })
    .catch((error) => {
      captureException(error, { extra: { startDate, endDate } })
      return []
    })
}

export default getEarningsSummary
